exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../assets/typography.pcss"), undefined);

// module
exports.push([module.id, ".ResetSearch__resetSearch___scwNB a{padding:12px 24px;border:1px solid #004f5c;background:#fff;color:#004f5c;font-size:12px;text-align:left;transition:left .3s;cursor:pointer;margin-right:-1px;float:left;border-radius:4px;height:40px;box-sizing:border-box;margin-left:30px}.ResetSearch__resetSearch___scwNB a:hover{background:#f3f3f3;color:#b6b6b6}@media(max-width:480px){.ResetSearch__resetSearch___scwNB a{float:none;margin:0;margin-bottom:20px;display:inline-block;padding:6px 12px;height:auto}}", ""]);

// exports
exports.locals = {
	"resetSearch": "ResetSearch__resetSearch___scwNB " + require("-!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../assets/typography.pcss").locals["bodyText"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/ResetSearch/ResetSearch.pcss
// module id = 934
// module chunks = 0